export * from './useAutomationCommunicationStandalone';
